import { atom } from 'jotai';

const token = localStorage.getItem('token') || null;
const user = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null;
const role = localStorage.getItem('role') || null;
const subscriptionId = localStorage.getItem('subscriptionId') ?? null;

export const loaderState = atom(false);

export const userInfoAtom = atom({
	token: token || null,
	user: user || null,
	role: role || null,
	subscriptionId: subscriptionId || null
});

// Sync search query globally
const getInitialSearchQuery = () => {
	try {
		return new URLSearchParams(window.location.search).get('search_query') || '';
	} catch (e) {
		return '';
	}
};
export const searchQueryAtom = atom(getInitialSearchQuery());

